import Link from 'next/link';
import Badge from '@core/components/badge/Badge';

import UseSlugRoute from 'hooks/use-slugroute';

import { Progressing, Completed } from 'constants/content-status';

import EmptyCircle from 'assets/icons/empty-circle.svg';
import ArrowRight from 'assets/icons/arrow-right.svg';
import InProgressIcon from 'assets/icons/inprogress-circle.svg';
import CompletedIcon from 'assets/icons/completed-circle.svg';

import classes from './ContentCurriculum.module.scss';

const ContentCurriculum = ({ data, content_type = 'course' }) => {
	const slugRoute = UseSlugRoute();
	return (
		data && (
			<div className={`${classes['content-curriculum-wrapper']}`}>
				<ul>
					{data.map((objective, index) => {
						if (content_type === 'course') {
							return (
								<li key={objective.title}>
									<div className={`${classes['courses_curriculum__icon']}`}>
										<i>
											<EmptyCircle />
										</i>
									</div>
									<div className={`${classes['courses_curriculum__content']} w-100`}>
										<h5>Learning Objective {index + 1}</h5>
										<h4>{objective.title}</h4>
									</div>
								</li>
							);
						} else if (content_type === 'job-qualification') {
							return (
								<Link
									key={objective.id}
									href={slugRoute(`/courses/${objective.id}`, objective.slug)}
									className={`${classes['lectures__event']} animated fadeInUp delay-3s `}>
									<div className={`${classes['lectures__event__icon']}`}>
										<i className="">
											{objective.status === Completed || objective.status === Progressing ? (
												objective.status === Completed ? (
													<CompletedIcon />
												) : (
													<InProgressIcon />
												)
											) : (
												<EmptyCircle />
											)}
											{/* <EmptyCircle /> */}
										</i>
									</div>
									<div className={`${classes['lectures__event__content']} w-100`}>
										<div
											className={`${classes['lectures__event__content__title']} d-flex flex-row justify-content-between align-items-center`}>
											<img src={objective.image} alt={objective.title} />
											<div
												className={`${classes['lectures__event__content__title__detail']} d-flex flex-column justify-content-between gap-2`}>
												<div
													className={`${classes['lectures__event__content__title__detail']} d-flex flex-row align-items-center`}>
													{(objective.status === Completed || objective.status === Progressing) && (
														<Badge status={objective.status} />
													)}
													<h5>Course #{objective.position}</h5>
												</div>
												<h4>{objective.title}</h4>
												<div className={`${classes['lectures__event__description']}`}>
													<p>{objective.short_introduction}</p>
												</div>
											</div>
											<ArrowRight />
										</div>
									</div>
								</Link>
							);
						}
					})}
				</ul>
			</div>
		)
	);
};

export default ContentCurriculum;
